"use client";

import { Input } from "@/app/components/ui/input";
import { SearchIcon } from "lucide-react";

type ListingSearchInputPropsT = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export default function ListingSearchInput({
  value,
  onChange,
  placeholder = "Suche",
}: ListingSearchInputPropsT) {
  return (
    <div className="relative flex w-full flex-row items-center gap-2">
      <SearchIcon className="absolute top-1/2 left-4 z-10 size-4 -translate-y-1/2 opacity-50" />
      <Input
        containerClassName="h-12.5 overflow-hidden"
        className="bg-background border-input focus:border-input focus-visible:border-input inline-block border pl-10 shadow-xs focus-visible:ring-0 max-lg:h-[3.571429rem] max-lg:w-[114.285714%] max-lg:origin-top-left max-lg:scale-[0.875] max-lg:pl-[2.857rem] lg:h-12.5 lg:text-sm"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
